module.exports = __webpack_public_path__ + "static/media/desktop-step2.9b1f05cc.png";